export default __webpack_public_path__ + "static/media/item1.539290b4.png";